import React from 'react'

const EmptyStateIcon = () => (
  <svg
    width="119"
    height="118"
    viewBox="0 0 119 118"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_974_15195)">
      <rect x="0.642578" width="118" height="118" rx="59" fill="#EAEFFF" />
    </g>
    <rect
      x="1.14258"
      y="0.5"
      width="117"
      height="117"
      rx="58.5"
      stroke="url(#paint0_linear_974_15195)"
    />
    <path
      className="sparkle"
      style={{ animationDelay: `${400}ms` }}
      d="M26.8704 94.5045C26.7818 94.3083 26.5033 94.3083 26.4147 94.5045L25.4369 96.6694C25.4119 96.7249 25.3675 96.7693 25.312 96.7944L23.147 97.7722C22.9509 97.8607 22.9509 98.1393 23.147 98.2278L25.312 99.2056C25.3675 99.2307 25.4119 99.2751 25.4369 99.3306L26.4147 101.496C26.5033 101.692 26.7818 101.692 26.8704 101.496L27.8482 99.3306C27.8733 99.2751 27.9177 99.2307 27.9732 99.2056L30.1381 98.2278C30.3342 98.1393 30.3342 97.8607 30.1381 97.7722L27.9732 96.7944C27.9177 96.7693 27.8733 96.7249 27.8482 96.6694L26.8704 94.5045Z"
      fill="#151B56"
    />
    <path
      className="sparkle"
      style={{ animationDelay: `${460}ms` }}
      d="M7.82485 67.4036C7.75399 67.2467 7.53117 67.2467 7.46031 67.4036L7.05142 68.3089C7.03138 68.3533 6.99584 68.3888 6.95147 68.4088L6.04615 68.8177C5.88925 68.8886 5.88925 69.1114 6.04615 69.1823L6.95147 69.5912C6.99584 69.6112 7.03138 69.6467 7.05142 69.6911L7.46031 70.5964C7.53117 70.7533 7.75399 70.7533 7.82485 70.5964L8.23374 69.6911C8.25378 69.6467 8.28931 69.6112 8.33368 69.5912L9.23901 69.1823C9.39591 69.1114 9.39591 68.8886 9.23901 68.8177L8.33368 68.4088C8.28931 68.3888 8.25378 68.3533 8.23374 68.3089L7.82485 67.4036Z"
      fill="#151B56"
    />
    <path
      className="sparkle"
      style={{ animationDelay: `${520}ms` }}
      d="M2.87042 88.4955C2.78184 88.6917 2.50332 88.6917 2.41474 88.4955L1.74807 87.0194C1.72302 86.964 1.6786 86.9196 1.62313 86.8945L0.147043 86.2278C-0.0490866 86.1393 -0.0490861 85.8607 0.147043 85.7722L1.62313 85.1055C1.6786 85.0804 1.72302 85.036 1.74807 84.9806L2.41474 83.5045C2.50332 83.3083 2.78184 83.3083 2.87042 83.5045L3.53709 84.9806C3.56214 85.036 3.60656 85.0804 3.66202 85.1055L5.13811 85.7722C5.33424 85.8607 5.33424 86.1393 5.13811 86.2278L3.66202 86.8945C3.60656 86.9196 3.56214 86.964 3.53709 87.0194L2.87042 88.4955Z"
      fill="#151B56"
    />
    <path
      className="sparkle"
      style={{ animationDelay: `${580}ms` }}
      d="M113.415 38.5045C113.503 38.3083 113.782 38.3083 113.87 38.5045L114.848 40.6694C114.873 40.7249 114.918 40.7693 114.973 40.7944L117.138 41.7722C117.334 41.8607 117.334 42.1393 117.138 42.2278L114.973 43.2056C114.918 43.2307 114.873 43.2751 114.848 43.3306L113.87 45.4955C113.782 45.6917 113.503 45.6917 113.415 45.4955L112.437 43.3306C112.412 43.2751 112.367 43.2307 112.312 43.2056L110.147 42.2278C109.951 42.1393 109.951 41.8607 110.147 41.7722L112.312 40.7944C112.367 40.7693 112.412 40.7249 112.437 40.6694L113.415 38.5045Z"
      fill="#151B56"
    />
    <path
      className="sparkle"
      style={{ animationDelay: `${640}ms` }}
      d="M114.46 25.4036C114.531 25.2467 114.754 25.2467 114.825 25.4036L115.234 26.3089C115.254 26.3533 115.289 26.3888 115.334 26.4088L116.239 26.8177C116.396 26.8886 116.396 27.1114 116.239 27.1823L115.334 27.5912C115.289 27.6112 115.254 27.6467 115.234 27.6911L114.825 28.5964C114.754 28.7533 114.531 28.7533 114.46 28.5964L114.051 27.6911C114.031 27.6467 113.996 27.6112 113.951 27.5912L113.046 27.1823C112.889 27.1114 112.889 26.8886 113.046 26.8177L113.951 26.4088C113.996 26.3888 114.031 26.3533 114.051 26.3089L114.46 25.4036Z"
      fill="#151B56"
    />
    <path
      className="sparkle"
      style={{ animationDelay: `${700}ms` }}
      d="M101.825 19.4036C101.754 19.2467 101.531 19.2467 101.46 19.4036L101.051 20.3089C101.031 20.3533 100.996 20.3888 100.951 20.4088L100.046 20.8177C99.8892 20.8886 99.8892 21.1114 100.046 21.1823L100.951 21.5912C100.996 21.6112 101.031 21.6467 101.051 21.6911L101.46 22.5964C101.531 22.7533 101.754 22.7533 101.825 22.5964L102.234 21.6911C102.254 21.6467 102.289 21.6112 102.334 21.5912L103.239 21.1823C103.396 21.1114 103.396 20.8886 103.239 20.8177L102.334 20.4088C102.289 20.3888 102.254 20.3533 102.234 20.3089L101.825 19.4036Z"
      fill="#151B56"
    />
    <path
      d="M107.412 47.5152V70.0153C107.412 77.4853 102.912 83.5153 93.912 83.5153H30.9121C21.9121 83.5153 17.4121 77.4853 17.4121 70.0153V47.5152C17.4121 46.6602 17.5021 45.8502 17.5921 45.0402C19.4371 45.8052 20.8771 47.3352 21.4171 49.3152L22.5871 53.6802C23.3071 56.3802 25.5571 58.0903 28.3021 58.0903C31.0471 58.0903 33.2971 56.3802 34.0171 53.7252L35.1871 49.4052C35.8171 47.1102 37.4821 45.4452 39.7771 44.8152L44.2321 43.6002C46.7124 42.8194 48.5071 40.597 48.5071 37.9752C48.5071 36.4452 47.9671 35.0952 47.0221 34.0152H93.912C102.912 34.0152 107.412 40.0452 107.412 47.5152Z"
      fill="#151B56"
    />
    <path
      d="M86.037 70.0153C86.037 71.8603 84.507 73.3903 82.662 73.3903H42.1621C40.3171 73.3903 38.7871 71.8603 38.7871 70.0153C38.7871 68.1703 40.3171 66.6403 42.1621 66.6403H82.662C84.507 66.6403 86.037 68.1703 86.037 70.0153Z"
      fill="#EAEFFF"
    />
    <path
      d="M88.2871 49.7652C88.2871 51.6102 86.7571 53.1402 84.9121 53.1402H75.9121C74.0671 53.1402 72.5371 51.6102 72.5371 49.7652C72.5371 47.9202 74.0671 46.3902 75.9121 46.3902H84.9121C86.7571 46.3902 88.2871 47.9202 88.2871 49.7652Z"
      fill="#EAEFFF"
    />
    <path
      className="sparkle sparkle-big"
      opacity="0.6"
      d="M44.0976 37.885C44.0976 38.2 43.9176 38.92 43.0626 39.19L38.6526 40.405C34.8276 41.44 31.9476 44.32 30.9126 48.145L29.7426 52.465C29.4726 53.455 28.7076 53.545 28.3476 53.545C27.9876 53.545 27.2226 53.455 26.9526 52.465L25.7826 48.1C24.7476 44.32 21.8226 41.44 18.0426 40.405L13.6776 39.235C12.7326 38.965 12.6426 38.155 12.6426 37.84C12.6426 37.48 12.7326 36.67 13.6776 36.4L18.0876 35.23C21.8676 34.15 24.7476 31.27 25.7826 27.49L27.0426 22.9C27.3576 22.135 28.0776 22 28.3476 22C28.6176 22 29.3826 22.09 29.6526 22.81L30.9126 27.445C31.9476 31.225 34.8726 34.105 38.6526 35.185L43.1526 36.445C44.0526 36.805 44.0976 37.615 44.0976 37.885Z"
      fill="#151B56"
    />
    <defs>
      <filter
        id="filter0_i_974_15195"
        x="0.642578"
        y="0"
        width="118"
        height="122"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="5" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.854902 0 0 0 0 0.898039 0 0 0 0 1 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_974_15195" />
      </filter>
      <linearGradient
        id="paint0_linear_974_15195"
        x1="-2.85742"
        y1="-3"
        x2="120.643"
        y2="105"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DAE5FF" />
        <stop offset="0.490385" stopColor="#DAE5FF" stopOpacity="0" />
        <stop offset="1" stopColor="#DAE5FF" />
      </linearGradient>
    </defs>
  </svg>
)

export default EmptyStateIcon
